export const REQUEST_UPLOAD_EMAIL_FILES = 'REQUEST_UPLOAD_EMAIL_FILES';
